export default __webpack_public_path__ + "static/media/collaborator-signature-mutual.2efd2fc8.svg";